const Component = {
  render: function render() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c('div', [
      _c('h1', { staticClass: 'uk-h1 tm-heading-fragment' }, [
        _vm._v('HeightViewport')
      ]),
      _vm._m(0),
      _vm._v(' '),
      _vm._m(1),
      _c('hr', { staticClass: 'uk-margin-large' }),
      _vm._m(2),
      _vm._m(3),
      _c(
        'p',
        [
          _c('vk-label', [_vm._v('Note')]),
          _vm._v(
            ' You can learn about directives and how to apply options at the '
          ),
          _c(
            'router-link',
            { staticClass: 'tm-internal-link', attrs: { to: 'directives' } },
            [_vm._v('Directives guide')]
          ),
          _vm._v('.')
        ],
        1
      )
    ])
  },
  staticRenderFns: [
    function() {
      var _vm = this
      var _h = _vm.$createElement
      var _c = _vm._self._c || _h
      return _c('p', [
        _vm._v('Add the '),
        _c('code', [_vm._v('v-vk-height-viewport')]),
        _vm._v(
          ' directive to an element to expand it height as of the entire viewport. You can change the height behavior by setting the '
        ),
        _c('code', [_vm._v('offset-top')]),
        _vm._v(', '),
        _c('code', [_vm._v('offset-bottom')]),
        _vm._v(' or '),
        _c('code', [_vm._v('expand')]),
        _vm._v(' options.')
      ])
    },
    function() {
      var _vm = this
      var _h = _vm.$createElement
      var _c = _vm._self._c || _h
      return _c('div', { staticClass: 'uk-margin-medium' }, [
        _c('pre', [
          _c('code', { staticClass: 'lang-html hljs' }, [
            _c('span', { staticClass: 'hljs-tag' }, [
              _vm._v('<'),
              _c('span', { staticClass: 'hljs-name' }, [_vm._v('div')]),
              _vm._v(' '),
              _c('span', { staticClass: 'hljs-attr' }, [
                _vm._v('v-vk-height-viewport')
              ]),
              _vm._v('>')
            ]),
            _c('span', { staticClass: 'hljs-tag' }, [
              _vm._v('</'),
              _c('span', { staticClass: 'hljs-name' }, [_vm._v('div')]),
              _vm._v('>')
            ]),
            _vm._v('\n\n'),
            _c('span', { staticClass: 'hljs-tag' }, [
              _vm._v('<'),
              _c('span', { staticClass: 'hljs-name' }, [_vm._v('div')]),
              _vm._v(' '),
              _c('span', { staticClass: 'hljs-attr' }, [
                _vm._v('v-vk-height-viewport.offsetTop')
              ]),
              _vm._v('>')
            ]),
            _c('span', { staticClass: 'hljs-tag' }, [
              _vm._v('</'),
              _c('span', { staticClass: 'hljs-name' }, [_vm._v('div')]),
              _vm._v('>')
            ]),
            _vm._v('\n\n'),
            _c('span', { staticClass: 'hljs-tag' }, [
              _vm._v('<'),
              _c('span', { staticClass: 'hljs-name' }, [_vm._v('div')]),
              _vm._v(' '),
              _c('span', { staticClass: 'hljs-attr' }, [
                _vm._v('v-vk-height-viewport')
              ]),
              _vm._v('='),
              _c('span', { staticClass: 'hljs-string' }, [
                _vm._v('"{ offsetBottom: 20 }"')
              ]),
              _vm._v('>')
            ]),
            _c('span', { staticClass: 'hljs-tag' }, [
              _vm._v('</'),
              _c('span', { staticClass: 'hljs-name' }, [_vm._v('div')]),
              _vm._v('>')
            ]),
            _vm._v('\n\n'),
            _c('span', { staticClass: 'hljs-tag' }, [
              _vm._v('<'),
              _c('span', { staticClass: 'hljs-name' }, [_vm._v('div')]),
              _vm._v(' '),
              _c('span', { staticClass: 'hljs-attr' }, [
                _vm._v('v-vk-height-viewport.expand')
              ]),
              _vm._v('>')
            ]),
            _c('span', { staticClass: 'hljs-tag' }, [
              _vm._v('</'),
              _c('span', { staticClass: 'hljs-name' }, [_vm._v('div')]),
              _vm._v('>')
            ]),
            _vm._v('\n\n'),
            _c('span', { staticClass: 'hljs-tag' }, [
              _vm._v('<'),
              _c('span', { staticClass: 'hljs-name' }, [_vm._v('div')]),
              _vm._v(' '),
              _c('span', { staticClass: 'hljs-attr' }, [
                _vm._v('v-vk-height-viewport')
              ]),
              _vm._v('='),
              _c('span', { staticClass: 'hljs-string' }, [
                _vm._v('"{ min-height: 300 }"')
              ]),
              _vm._v('>')
            ]),
            _c('span', { staticClass: 'hljs-tag' }, [
              _vm._v('</'),
              _c('span', { staticClass: 'hljs-name' }, [_vm._v('div')]),
              _vm._v('>')
            ])
          ])
        ])
      ])
    },
    function() {
      var _vm = this
      var _h = _vm.$createElement
      var _c = _vm._self._c || _h
      return _c(
        'h2',
        { staticClass: 'uk-h2 tm-heading-fragment', attrs: { id: 'options' } },
        [_c('a', { attrs: { href: '#options' } }, [_vm._v('Options')])]
      )
    },
    function() {
      var _vm = this
      var _h = _vm.$createElement
      var _c = _vm._self._c || _h
      return _c('div', { staticClass: 'uk-overflow-auto' }, [
        _c('table', { staticClass: 'uk-table uk-table-divider' }, [
          _c('thead', [
            _c('tr', [
              _c('th', [_vm._v('Name')]),
              _vm._v(' '),
              _c('th', [_vm._v('Type')]),
              _vm._v(' '),
              _c('th', [_vm._v('Default')]),
              _vm._v(' '),
              _c('th', [_vm._v('Description')])
            ])
          ]),
          _vm._v(' '),
          _c('tbody', [
            _c('tr', [
              _c('td', [_c('code', [_vm._v('offsetTop')])]),
              _vm._v(' '),
              _c('td', [_vm._v('Boolean')]),
              _vm._v(' '),
              _c('td', [_c('code', [_vm._v('false')])]),
              _vm._v(' '),
              _c('td', [
                _vm._v("Subtracts the element's top offset from its height.")
              ])
            ]),
            _vm._v(' '),
            _c('tr', [
              _c('td', [_c('code', [_vm._v('offsetBottom')])]),
              _vm._v(' '),
              _c('td', [_vm._v('Boolean, Number, Pixel')]),
              _vm._v(' '),
              _c('td', [_c('code', [_vm._v('false')])]),
              _vm._v(' '),
              _c('td', [
                _vm._v(
                  "Subtracts the element's immediately following sibling's height from its own height."
                )
              ])
            ]),
            _vm._v(' '),
            _c('tr', [
              _c('td', [_c('code', [_vm._v('expand')])]),
              _vm._v(' '),
              _c('td', [_vm._v('Boolean')]),
              _vm._v(' '),
              _c('td', [_c('code', [_vm._v('true')])]),
              _vm._v(' '),
              _c('td', [
                _vm._v(
                  "Expand the element's height to make a short page fill the viewport."
                )
              ])
            ]),
            _vm._v(' '),
            _c('tr', [
              _c('td', [_c('code', [_vm._v('minHeight')])]),
              _vm._v(' '),
              _c('td', [_vm._v('Number')]),
              _vm._v(' '),
              _c('td', [_c('code', [_vm._v('0')])]),
              _vm._v(' '),
              _c('td', [
                _vm._v(
                  'Sets a minimum height. Useful if the all children are positioned absolute.'
                )
              ])
            ])
          ])
        ])
      ])
    }
  ],
  data: function() {
    return {}
  },
  scrollToTop: true,
  sections: [{ id: 'options', title: 'Options' }],
  components: {}
}


export default Component
